
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bereken-bijdrage",
      function () {
        return require("private-next-pages/bereken-bijdrage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bereken-bijdrage"])
      });
    }
  